"use strict";

angular.module("core").component("termsOfServiceContent", {
    templateUrl: require("./terms-of-service-content.component.html"),
    controller: function($scope, $rootScope, $resource, Language, $sce, appConfig, APP_OWNER) {
        var service = $resource(appConfig.API_SERVER + "/auth/" + appConfig.APP + "/terms-of-service/");
        var unregister = Language.initializeController(this, "language", null);

        this.$onDestroy = function() {
            unregister();
        };

        this.terms_of_service = service.get({owner: APP_OWNER});
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/terms-of-service/terms-of-service-content/terms-of-service-content.component.js
// module id = 557
// module chunks = 0